import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { TUTORIAL_CONTENT } from "../../data/tutorialContent";

export function TutorialModal({ topic, open, onOpenChange }) {
  const content = TUTORIAL_CONTENT[topic];
  if (!content) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#151613] border-white/10 text-[#f1e0c5] max-w-2xl p-0 overflow-hidden" data-testid={`tutorial-modal-${topic}`}>
        <div className="h-36 md:h-44 overflow-hidden relative">
          <img src={content.image} alt={content.name} className="object-cover w-full h-full" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#151613] via-[#151613]/40 to-transparent" />
        </div>
        <DialogHeader className="px-6 pt-0 -mt-10 relative z-10">
          <DialogTitle className="font-display text-3xl" style={{ color: content.accent }}>{content.name}</DialogTitle>
          <DialogDescription className="text-[#f1e0c5]/60">{content.tagline}</DialogDescription>
        </DialogHeader>
        <div className="px-6 pb-6 pt-2 space-y-4 max-h-[50vh] overflow-y-auto scrollbar-thin">
          {content.sections.map((s, idx) => (
            <div key={idx} data-testid={`tutorial-section-${topic}-${idx}`}>
              <h4 className="text-xs uppercase tracking-widest mb-1.5" style={{ color: content.accent }}>{s.heading}</h4>
              <ul className="space-y-1">
                {s.bullets.map((b, i) => (
                  <li key={i} className="text-sm text-[#f1e0c5]/75 leading-relaxed pl-3 border-l border-white/10">{b}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
